import { Routes } from '@angular/router';
import { ScopeGuard } from '../auth/services/scope.guard';
import { SCOPES } from 'src/app/app.constants';

export const STUDENT_RECORDS_ROUTES: Routes = [
  {
    path: 'enrolment/:id', loadComponent: () => import('./components/enrolment-view/enrolment-view.component').then(m => m.EnrolmentViewComponent), canActivate: [ScopeGuard], data: { scopes: [SCOPES.enrolment.read] }, children: [
      { path: 'progress', loadComponent: () => import('./components/enrolment-view/progress/enrolment-progress.component').then(m => m.EnrolmentProgressComponent) },
      { path: '', loadComponent: () => import('./components/enrolment-view/overview/enrolment-overview.component').then(m => m.EnrolmentOverviewComponent) }
    ]
  },
  {
    path: 'cohort-progress', loadComponent: async () => await import('./components/module-projection/module-projection.component').then(m => m.ModuleProjectionComponent), canActivate: [ScopeGuard], data: { scopes: [SCOPES.studentRecords.read] }
  }
];
